import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { auth0 } from './auth0'
import { createPinia } from 'pinia'
import gtag from 'vue-gtag'
import hubspotChatWidgetLoader from './hubspot-chat-widget-loader'
import hotjarLoader from './hotjar-loader'
import PrimeVue from 'primevue/config'
import Tailwind from 'primevue/passthrough/tailwind'
import Tooltip from 'primevue/tooltip'
import { initSentry } from './sentry'

const isProduction = !!import.meta.env.PROD
const app = createApp(App)
const pinia = createPinia()
const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onSettled: () => {
        queryClient.invalidateQueries()
      }
    }
  }
})

app.directive('tooltip', Tooltip)
app.use(router)
initSentry(app, router)
app.use(auth0)
app.use(VueQueryPlugin, { queryClient })
app.use(pinia)
app.use(PrimeVue, {
  pt: Tailwind
})

if (isProduction) {
  app.use(
    gtag,
    {
      config: {
        id: 'G-XTZ0MF1Y53'
      }
    },
    router
  )
}

if (isProduction) {
  hubspotChatWidgetLoader()
  hotjarLoader()
}

app.mount('#app')
